import React from "react";
import USPSection2Cards from "../../components/USPSection2/USPSection2Cards";
import { Row, Col } from "react-bootstrap";
import Icon1 from "../../assets/images/USPIcons/check-mark.png";
import Icon3 from "../../assets/images/USPIcons/no-preservatives.png";
import Icon4 from "../../assets/images/USPIcons/ecology.png";
import Icon6 from "../../assets/images/USPIcons/organic.png";
import BestPrice from "../../assets/images/benefits/best-price.svg";

const ConsumerBenefit = () => {
  const benefits = [

    {
        image: Icon1,
        title: "Farm 2 Fork Traceability",
        bodycopy:
  "      Farm-to-Fork traceability is ensured for our honey products, providing transparency and quality assurance."    },
   
    {
      image: Icon3,
      title: "Chemical Preservative free honey",
      bodycopy:
        "ApisChain offers chemical preservative-free honey, ensuring pure and natural goodness in every drop.        ",
    },
    {
      image: Icon4,
      title:"Sustainably Produced",
      bodycopy:
        "ApisChain's honey is produced sustainably through practices such as organic beekeeping, habitat preservation, and minimal hive disturbance.        ",
    },

    {
      image: Icon6,
      title: "Organic honey ",
      bodycopy:
        "Experience the pure and natural goodness of our organic honey, sourced and produced with utmost care.        ",
    },
    {
      title: "Best Price",
      bodycopy:
        "Manufacturers benefit from securing the best price through optimized sourcing and bulk purchasing, ensuring cost savings and maximizing profitability.",
      image: BestPrice,
    },
  ];
  return (
    <>
      <Row>
        {benefits.map((e, index) => {
          return (
            <Col md={4} key={index}>
              <USPSection2Cards
                cardtitle={e.title}
                src={e.image}
                cardBodycopy={e.bodycopy}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default ConsumerBenefit;
